import {
  globalAgent
} from 'http'
import CONSTANTS_GLOBAL from '@/constants/GLOBAL'
// set function parseTime,formatTime to filter

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [{
      value: 1e18,
      symbol: 'E'
    },
    {
      value: 1e15,
      symbol: 'P'
    },
    {
      value: 1e12,
      symbol: 'T'
    },
    {
      value: 1e9,
      symbol: 'G'
    },
    {
      value: 1e6,
      symbol: 'M'
    },
    {
      value: 1e3,
      symbol: 'k'
    }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
        .toFixed(digits)
        .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num.toString()
}

export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 税率格式化 小数点后5位
export function toExchangeRateFilter(val) {
  return val.toFixed(5)
  // val = val.toString().replace(/\$|\,/g,'');
  //   if(isNaN(val)) {
  //     val = "0";
  //   }
  //   let sign = (val == (val = Math.abs(val)));
  //   val = Math.floor(val*100+0.50000000001);
  //   let cents = val%100;
  //   val = Math.floor(val/100).toString();
  //   if(cents<10) {
  //      cents = "0" + cents
  //   }
  //   for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
  //       val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
  //   }

  //   return (((sign)?'':'-') + val + '.' + cents);
}


export function toGlobleStatusFilter(status) {
  switch (status) {
    case CONSTANTS_GLOBAL.STATUS_ENABLE:
      return '启用'
    case CONSTANTS_GLOBAL.STATUS_DISABLE:
      return '禁用'
    default:
      return '未知'
  }
}

export function toGlobleRegisterFilter(status) {
  switch (status) {
    case CONSTANTS_GLOBAL.STATUS_ENABLE:
      return '未注册'
    case CONSTANTS_GLOBAL.STATUS_DISABLE:
      return '已注册'
    default:
      return '未知'
  }
}

export function toGlobleNullFilter(column) {
  if (column) {
    return column
  } else {
    return "--"
  }
}

export function toGlobleApprovalFilter(checkStatus) {
  switch (checkStatus) {
    case 0:
      return '待审核'
    case 1:
      return '审核中'
    case 2:
      return '审核通过'
    case 3:
      return '审核未通过'
    case 4:
      return '已撤回'
  }
}

/**
 * 设置显示的精度
 * @param {*} value 需要设置精度的值
 * @param {*} precision 精度位数
 * @returns 
 */
export function numberPrecision(value, precision = 2) {
  if (!value) {
    let r = 0
    return r.toFixed(precision)
  }
  return Number(value).toFixed(precision);
}

/**
 * 隐藏sku标题
 * @param {*} value sku文本
 * @returns 
 */
 export function skuFormat(value) {
  let skuTextRes = "";
  if (value) {
    let skuTextArr = value.split(";");
    skuTextArr.forEach((t) => {
      if(!!t){
        skuTextRes += t.split(":")[1] + ";";
      }
    });
    skuTextRes = skuTextRes.substring(0, skuTextRes.length - 1);
  }
  return skuTextRes;
}